import store from "store";

export const SET_CLIENT = "CLIENT:SET_CLIENT";

export const setClient = (client) => {
	store.dispatch({type: SET_CLIENT, client});
};

export default {
	setClient
}
